/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { IAjaxProvider } from 'jinqu';
import { LinqService, QueryOptions } from 'linquest';
import {
  PerformanceFormTemplateGroupParameterDto,
} from './models';

/**
 * PerformanceFormTemplateGroupParameterApi - API class
 */
export class PerformanceFormTemplateGroupParameterApi extends LinqService {

  /**
   * Creates a new PerformanceFormTemplateGroupParameterApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider);
  }

  /**
   * @param dto 
   */
  addOrUpdateAsync(dto?: PerformanceFormTemplateGroupParameterDto, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplateGroupParameter/AddOrUpdateAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  deleteAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplateGroupParameter/DeleteAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplateGroupParameter/GetAsync`;
    let query = this.createQuery<PerformanceFormTemplateGroupParameterDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param performanceFormDetailId 
   */
  getPerformanceFormTemplateGroupParameterWithFormDetailId(performanceFormDetailId?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplateGroupParameter/GetPerformanceFormTemplateGroupParameterWithFormDetailId`;
    let query = this.createQuery<PerformanceFormTemplateGroupParameterDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'performanceFormDetailId', value: performanceFormDetailId && performanceFormDetailId.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param performanceFormId 
   */
  getPerformanceFormTemplateGroupParameterWithFormId(performanceFormId?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplateGroupParameter/GetPerformanceFormTemplateGroupParameterWithFormId`;
    let query = this.createQuery<PerformanceFormTemplateGroupParameterDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'performanceFormId', value: performanceFormId && performanceFormId.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getTranslatedAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplateGroupParameter/GetTranslatedAsync`;
    let query = this.createQuery<PerformanceFormTemplateGroupParameterDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   */
  list(options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplateGroupParameter/List`;
    let query = this.createQuery<PerformanceFormTemplateGroupParameterDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   */
  listTranslated(options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplateGroupParameter/ListTranslated`;
    let query = this.createQuery<PerformanceFormTemplateGroupParameterDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * @param dto 
   */
  saveAsync(dto?: PerformanceFormTemplateGroupParameterDto, options?: QueryOptions) {
    // create query
    const url = `/PerformanceFormTemplateGroupParameter/SaveAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }
}
